module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_8004.361b5e90.png";